/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const VolumeOffIconConfig = {
  name: 'VolumeOffIcon',
  height: 512,
  width: 256,
  svgPath: 'M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(VolumeOffIconConfig);